export default __webpack_public_path__ + "c99d18c14ba2f8b0c9c481897613770a.png";